/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/21/20
 * Time: 2:13 PM
 */
import React, {Component} from 'react';
import {MDBModal} from "mdbreact";

import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import {Col, Row} from "reactstrap";
import {Button, Checkbox, Dropdown, Form, Input} from "semantic-ui-react";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";
import * as common from "../../../../const/Common/CommonFunc";
import * as util from "../../../../util/Validator";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import * as routeConstants from "../../../../const/route/Route";
import '../../../../containers/VisitorRegistrationForm/Registration.css'
import './Register.scss';
import axios from "../../../../axios/axios_authorization";
import apiConfig from "../../../../axios/axios_api_services";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import * as config from "../../../../const/config/config";
import * as qs from "qs";
import Cookies from "js-cookie";
import * as keys from "../../../../const/key/Key";

const initialState = {
  title: 'None', fname: '', lname: '', gender: 'None', mobile: '', switch: false,
  identification_type: 'NIC', identification_value: '', country: "Sri Lanka",
  city: "", province: null, postal_code: null, district: "", line1: "", line2: null, expireTime: 30,
  otp: '', isBlock: false, isTerms: false, pinRequired: true, warning_msg: '', isForeignNum: false
};

class App extends Component {
  state = Object.assign({}, initialState);

  onSwitch = (condition) => {
    this.setState({switch: condition})
  };

  resendPin = () => {
    this.setState({otp: ''});
    this.props.spinnerHandler(true);
    axios.post(apiConfig.GUEST_USER_SEND_OTP, {mobile: this.state.mobile})
      .then(response => {
        if (response.data.success) {
          this.setState({switch: true, expireTime: 30})
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(error => {
        common.checkErrorResponse(error);
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  handleChange = (name, length) => event => {
    let value = event.target.value;
    if (name === "mobile" || name === "otp") {
      let reg = /^\d+$/;
      if (reg.test(value) || value === "") {
        this.setState({
          [name]: value
        })
      }
    } else {
      this.setState({
        [name]: value
      })
    }
  };

  dropDownChange = name => (event, {value}) => {
    this.setState({
      [name]: value
    })
  };
  isValidate = (isOtp) => {
    let condition = false;
    const {otp, title, fname, lname, gender, mobile, identification_type, identification_value, line1, line2, district, city} = this.state;
    if (isOtp && otp === "" || fname.trim() === "" || lname.trim() === "" || mobile.trim() === "" || identification_value.trim() === "" ||
      title.trim() === "" || gender.trim() === "" || identification_type.trim() === ""
      //|| line1.trim() === '' || city.trim() === ''
    ) {
      isOtp && otp === "" ? common.notifyMessage("Please enter verification code") :
        fname.trim() === '' ? common.notifyMessage("Please enter your first name") :
          lname.trim() === '' ? common.notifyMessage("Please enter your last name") :
            mobile.trim() === '' ? common.notifyMessage("Please enter your mobile number") :
              identification_value.trim() === '' ? common.notifyMessage("Please enter your identity number") :
                // line1.trim() === '' ? common.notifyMessage("Please enter address line 1") :
                  // line2.trim() === '' ? common.notifyMessage("Please enter address line 2") :
                  //   city.trim() === '' ? common.notifyMessage("Please enter city") :
                      // district === '' ? common.notifyMessage("Please enter district") :
                        common.notifyMessage("Please enter all required fields..")
    } else {
      let isValid = util.identityValueValidator(identification_value, identification_type);
      if (isValid) {
        !this.state.isTerms ? common.notifyMessage("Please accept the Terms of Service to proceed") : condition = true
      }
    }

    if (condition) {
      if (isOtp) {
        swal({
          title: "Are you sure, you want to proceed?", icon: are_you_sure_icon, closeOnClickOutside: false,
          buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
        }).then((value) => {
          switch (value) {
            case "action":
              this.sendToBackend(false);
              break;
            default:
              break;
          }
        });
      } else {
        this.resendPin();
      }
    }
  };

  sendToBackend = () => {
    let {pinRequired, otp, title, fname, lname, mobile, identification_type, identification_value, gender, city, country, province, postal_code, district, line1, line2} = this.state;
    const obj = {
      "otp": otp,
      "title": title,
      "gender": gender,
      "first_name": fname,
      "last_name": lname,
      "identification_type": identification_type,
      "identification_value": identification_value,
      "mobile": mobile,
      "birthday": null,
      "address": {
        "city": city,
        "country": country,
        "district": district,
        "line1": line1,
        "line2": line2,
        "postal_code": postal_code,
        "province": province
      }
    };

    this.props.spinnerHandler(true);

    axios.post(apiConfig.GUEST_USER_REGISTRATION, obj)
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {

          if (!pinRequired) {
            this.setState({...initialState, isBlock: true, warning_msg: response.data.message});
            common.warningAlert(response.data.message, 0);
            return;
          }

          this.authHandler(response.data.message, mobile, otp);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        common.checkErrorResponse(error);
      })
      .finally(fin => {

      })
  };

  authHandler = (message, mobile, otp) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": "Basic " + config.CLIENT_SECRET
    };
    const data = {username: mobile, password: otp, grant_type: 'password'};

    axios.post(apiConfig.OAUTH, qs.stringify(data), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        Cookies.set(keys.ACCESS_TOKEN, response.data.access_token); //access-token
        Cookies.set(keys.REFRESH_TOKEN, response.data.refresh_token); // refresh-token
        localStorage.setItem(keys.GUEST_CACHE, "1");

        this.props.userHandler(response.data.user);
        this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/dashboard`)
      })
      .catch(error => {
        this.props.spinnerHandler(false);
        if (error.status === 403) {
          common.warningAlert(error.statusDesc, 0, 3);
        } else {
          common.warningAlert("Authentication error occurred!", 0, 3);
        }
      })
      .finally(fin => {

      })
  };
  countDown = () => {
    let {expireTime} = this.state;
    if (expireTime > 0) {
      this.setState({expireTime: (expireTime - 1)})
    }
  };

  componentWillMount() {
    let state = this.props.location.state;
    if (state === undefined) {
      this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/login`);
    } else {
      this.setState({
        mobile: state.mobile,
        pinRequired: state.pinRequired,
        isForeignNum: !state.mobile.startsWith("94")
      })
    }
  }

  componentDidMount() {
    this.timer = setInterval(this.countDown, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    let {expireTime, isBlock} = this.state;
    return (
      <div className={"guest-user-reg-form"}>
        <div className={"user-reg-form"}>
          <h4 className={"reg-form-main-topic"}>
            <span><span className={"lng-eng"}>Registration</span> / <span
              className={"lng-sin"}>ලියාපදිංචි කිරීම</span> / <span className={"lng-tml"}>பதிவீடு</span></span>
          </h4>
          <Row>
            {/*<Col xs={12} lg={4}>*/}
              {/*<Row>*/}
                {/*<Col xs={12} lg={4}>*/}
                  {/*<Form>*/}
                    {/*<Form.Group widths='equal'>*/}
                    {/*<DrpDwn*/}
                      {/*required*/}
                      {/*tagText={<span>Title</span>}*/}
                      {/*placeholder={"Title"}*/}
                      {/*options={DropDownConst.userTitle}*/}
                      {/*value={this.state.title}*/}
                      {/*onChange={this.dropDownChange('title')}*/}
                    {/*/>*/}
                    {/*</Form.Group>*/}
                  {/*</Form>*/}
                {/*</Col>*/}
                {/*<Col xs={12} lg={8}>*/}
                  {/*<Form>*/}
                    {/*<Form.Group widths='equal'>*/}
                    {/*<DrpDwn*/}
                      {/*required*/}
                      {/*tagText={<span>Gender / <span className={"lng-sin"}>ස්ත්රී පුරුෂ භාවය</span> / <span*/}
                        {/*className={"lng-tml"}>பால்</span></span>}*/}
                      {/*placeholder={"Gender"}*/}
                      {/*options={DropDownConst.gender}*/}
                      {/*value={this.state.gender}*/}
                      {/*onChange={this.dropDownChange('gender')}*/}
                    {/*/>*/}
                    {/*</Form.Group>*/}
                  {/*</Form>*/}
                {/*</Col>*/}
              {/*</Row>*/}
            {/*</Col>*/}

            <Col xs={12} lg={6}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    required
                    tagText={<span><span>First Name</span> / <span className={"lng-sin"}>මුල් නම</span> / <span
                      className={"lng-tml"}>முதல் பெயர்</span> </span>}
                    placeholder={"First Name"}
                    value={this.state.fname}
                    onChange={this.handleChange('fname')}
                  />
                </Form.Group>
              </Form>
            </Col>

            <Col xs={12} lg={6}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    required
                    tagText={<span><span> Last Name / </span><span className={"lng-sin"}>අවසන් නම</span> / <span
                      className={"lng-tml"}>கடைசி பெயர்</span> </span>}
                    placeholder={"Last Name"}
                    value={this.state.lname}
                    onChange={this.handleChange('lname')}
                  />

                </Form.Group>
              </Form>
            </Col>

          </Row>

          <Row>
            <Col xs={12} lg={6}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    required
                    tagText={<span><span>Mobile / </span><span className={"lng-sin"}>ජංගම දූරකථන අංකය</span> / <span
                      className={"lng-tml"}>கைபேசி எண்</span> </span>}
                    placeholder={"07XXXXXXXX"}
                    value={this.state.mobile}
                    // onChange={this.handleChange('mobile')}
                  />

                </Form.Group>
              </Form>
            </Col>

            {/*<Col xs={12} lg={4}>*/}
              {/*<Form>*/}
                {/*<Form.Group widths='equal'>*/}
                  {/*<DrpDwn*/}
                    {/*required*/}
                    {/*tagText={<span><span>Identification Type / </span><span className={"lng-sin"}>හඳුනාගැනීමේ වර්ගය</span> / <span*/}
                      {/*className={"lng-tml"}>அடையாள வகை</span> </span>}*/}
                    {/*placeholder={"Identification Type"}*/}
                    {/*options={DropDownConst.Identifications}*/}
                    {/*value={this.state.identification_type}*/}
                    {/*onChange={this.dropDownChange('identification_type')}*/}
                  {/*/>*/}
                {/*</Form.Group>*/}
              {/*</Form>*/}
            {/*</Col>*/}

            {/*<Col xs={12} lg={5}>*/}
              {/*<Form.Group widths='equal'>*/}
                {/*<Form>*/}
                  {/*<Form.Group widths='equal'>*/}
                    {/*<TxtLbl*/}
                      {/*required*/}
                      {/*tagText={<span><span className={"lng-eng"}>Identification Number</span> / <span*/}
                        {/*className={"lng-sin"}>හැඳුනුම්පත් අංකය</span> / <span*/}
                        {/*className={"lng-tml"}>அடையாள அட்டை எண்</span>  </span>}*/}
                      {/*placeholder={"Identification Number"}*/}
                      {/*value={this.state.identification_value}*/}
                      {/*onChange={this.handleChange('identification_value')}*/}
                    {/*/>*/}

                  {/*</Form.Group>*/}
                {/*</Form>*/}

              {/*</Form.Group>*/}
            {/*</Col>*/}

            <Col xs={12} lg={6} className={"required field undefined required-comp"}>
              <span>
                <span><span className={"lng-eng"}>Identification Number</span> / <span
                  className={"lng-sin"}>හැඳුනුම්පත් අංකය</span> / <span
                  className={"lng-tml"}>அடையாள அட்டை எண்</span>  </span>
              </span>
              <Input
                action={<Dropdown style={{width: 'auto!important'}}
                                  button basic floating
                                  options={DropDownConst.Identifications}
                                  value={this.state.identification_type}
                                  onChange={this.dropDownChange('identification_type')} className={"end-"}/>}
                input={<input onChange={this.handleChange('identification_value')} value={this.state.identification_value}/>}
                style={{width: '100%', marginBottom: '0.6em', height: '40px'}} className={"custom-drop-input left action"}
                placeholder={"Identification Number"}
              />
            </Col>
          </Row>

          {/*address*/}
          <Row>
            {/*<Col xs={12} lg={4}>*/}
              {/*<Form>*/}
                {/*<Form.Group widths='equal'>*/}
                  {/*<TxtLbl*/}
                    {/*required*/}
                    {/*tagText={<span><span className={"lng-eng"}>Address (Line 2)</span> / <span*/}
                      {/*className={"lng-sin"}>ලිපිනය</span> / <span className={"lng-tml"}>முகவரி</span> </span>}*/}
                    {/*placeholder={"Line 2"}*/}
                    {/*value={this.state.line2}*/}
                    {/*onChange={this.handleChange('line2')}*/}
                  {/*/>*/}

                {/*</Form.Group>*/}
              {/*</Form>*/}
            {/*</Col>*/}


          </Row>

          <Row>
            <Col xs={12} lg={6}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    // required
                    tagText={<span><span className={"lng-eng"}>Address</span> / <span
                      className={"lng-sin"}>ලිපිනය</span> / <span className={"lng-tml"}>முகவரி </span></span>}
                    placeholder={"Address"}
                    value={this.state.line1}
                    onChange={this.handleChange('line1')}
                  />

                </Form.Group>
              </Form>
            </Col>
            <Col xs={12} lg={6}>
              <Form>
                <Form.Group widths='equal'>
                  <TxtLbl
                    // required
                    tagText={<span><span className={"lng-eng"}>City</span> / <span
                      className={"lng-sin"}>නගරය</span> / <span className={"lng-tml"}>நகரம்</span> </span>}
                    placeholder={"City"}
                    value={this.state.city}
                    onChange={this.handleChange('city')}
                  />

                </Form.Group>
              </Form>
            </Col>

            {/*<Col xs={12} lg={4}>*/}
              {/*<Form>*/}
                {/*<Form.Group widths='equal'>*/}
                  {/*<TxtLbl*/}
                    {/*// required*/}
                    {/*tagText={<span><span className={"lng-eng"}>Postal Code</span> / <span className={"lng-sin"}>තැපැල් කේතය</span> / <span*/}
                      {/*className={"lng-tml"}>அஞ்சல் குறியீடு</span></span>}*/}
                    {/*placeholder={"Postal Code"}*/}
                    {/*value={this.state.postal_code}*/}
                    {/*onChange={this.handleChange('postal_code')}*/}
                  {/*/>*/}

                {/*</Form.Group>*/}
              {/*</Form>*/}
            {/*</Col>*/}

            {/*<Col xs={12} lg={4}>*/}
              {/*<Form>*/}
                {/*<Form.Group widths='equal'>*/}
                  {/*{*/}
                    {/*!isForeignNum ?*/}
                      {/*<DrpDwn*/}
                        {/*required*/}
                        {/*tagText={<span><span className={"lng-eng"}>District</span> / <span*/}
                          {/*className={"lng-sin"}>දිස්ත්‍රික්කය</span> / <span className={"lng-tml"}>மாவட்டம்</span></span>}*/}
                        {/*placeholder={"District"}*/}
                        {/*options={DropDownConst.districs}*/}
                        {/*value={this.state.district}*/}
                        {/*onChange={this.dropDownChange('district')}*/}
                      {/*/> :*/}
                      {/*<TxtLbl*/}
                        {/*required*/}
                        {/*tagText={<span><span className={"lng-eng"}>District</span> / <span*/}
                          {/*className={"lng-sin"}>දිස්ත්‍රික්කය</span> / <span className={"lng-tml"}>மாவட்டம்</span></span>}*/}
                        {/*placeholder={"District"}*/}
                        {/*value={this.state.district}*/}
                        {/*onChange={this.handleChange('district')}*/}
                      {/*/>*/}
                  {/*}*/}

                {/*</Form.Group>*/}
              {/*</Form>*/}
            {/*</Col>*/}

            {/*<Col xs={12} lg={4}>*/}
            {/*<Form>*/}
            {/*<Form.Group widths='equal'>*/}
            {/*<DrpDwn*/}
            {/*// required*/}
            {/*tagText={"Province / පළාත / மாகாணம்"}*/}
            {/*placeholder={"Province"}*/}
            {/*options={DropDownConst.provinces}*/}
            {/*value={this.state.province}*/}
            {/*onChange={this.dropDownChange('province')}*/}
            {/*/>*/}
            {/*</Form.Group>*/}
            {/*</Form>*/}
            {/*</Col>*/}
          </Row>
          <br/>
          <Row>
            {
              !isBlock ?
                <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px', marginTop: '15px'}}>
                  <Checkbox style={{cursor: 'pointer'}}
                            label={<label className={"align-left"}>
                                  <span className={"lng-eng"}> I accept the <a target="_blank"
                                                                               href={'/vms_privacy_policy/index.html'}> Terms of
                                  Service </a> | <a target="_blank" href={'https://www.dialog.lk/privacy-policy'}> Privacy
                                    Policy</a></span>.<br/>
                              සේවා කොන්දේසි සහ රහස්‍යතා ප්‍රතිපත්තිය මම පිළිගනිමි<br/>
                              சேவை விதிமுறைகள் மற்றும் தனியுரிமைக் கொள்கையை நான் ஏற்றுக்கொள்கிறேன்
                            </label>}
                            onChange={() => this.setState({isTerms: !this.state.isTerms})}
                            checked={this.state.isTerms}
                  />
                  <br/><br/>
                  <Button className="px-5" onClick={() => this.isValidate(false)}>Continue</Button>
                </Col>
                :
                <div className={"warning-done-page"}>
                  {this.state.warning_msg}
                </div>
            }
          </Row>
        </div>
        {
          this.state.switch &&
          <MDBModal isOpen={this.state.switch} toggle={() => {
          }} size="md" className={"user-verification-modal guest-reg-form"}>
            <h4 className={"reg-form-main-topic"}>OTP Verification</h4>
            <Row>
              <Col xs={12}>
                <p
                  className="warning-muted">{`We've sent a verification code to your ${this.state.mobile} mobile via SMS. Please provide it below`}</p>
              </Col>
              <Col xs={12}>
                <div className={"otp-form"}>
                  <Form>
                    <Form.Group widths='equal'>
                      <TxtLbl
                        required
                        tagText={"Verification Code"}
                        placeholder={"Verification Code"}
                        value={this.state.otp}
                        onChange={this.handleChange('otp')}
                      />
                    </Form.Group>
                  </Form>
                  {expireTime === 0 &&
                  <p className={"expire-text"}>{"Didn't receive the code? "} <label className={'resend-text'}
                                                                                    onClick={this.resendPin}>Resend</label>
                  </p>}
                  {expireTime !== 0 && <p className={"expire-text"}>Didn't receive the code?
                    00:<label>{expireTime < 10 ? `0${expireTime}` : expireTime}</label></p>}
                </div>
                <p className={"align-right"} style={{color: 'gray', textDecoration: 'underline', cursor: "pointer"}}
                   onClick={() => this.onSwitch(false)}>Change details</p>
              </Col>
              <Col xs={12}>
                <Button className="px-5" onClick={() => this.isValidate(true)}>Verify</Button>
              </Col>
            </Row>

          </MDBModal>
        }
      </div>
    );
  }
}

let txtStyle = {
  marginBottom: '10px',
  height: '45px',
  width: '100%'

};
const mapDispatchToProps = (dispatch) => {
  return {
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(null, mapDispatchToProps)(App);
